// ── 직원 관리 목록 불러오기 — 이 회사 직원 목록·재직/전체·휴대폰 너비·IP 별칭 ──────────────
// 2026-11-03 UserManagement.jsx(300줄)에서 옮김. 같은 날 합치기-1: 검색·거르기·쪽 넘기기는 usePeopleView.js 로
//   (이 회사 담당 3.3% 목록과 합친 뒤에 걸러야 해서).
import { useEffect, useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import {
  MOBILE_BREAKPOINT,
  normalizeDepartmentValue,
  normalizeAttendanceTimeType,
} from './utils';

function normalizeIpAliasOptions(rawAliases) {
  const labels = (Array.isArray(rawAliases) ? rawAliases : [])
    .map((item) => (typeof item === 'string' ? item : item?.label))
    .map((label) => String(label || '').trim())
    .filter(Boolean);
  return labels.filter((label, index, arr) => arr.indexOf(label) === index);
}

export function useUserList({ apiBase, entityLabel, attendanceTypeOptions, showToast }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT);
  const [includeResigned, setIncludeResigned] = useState(false);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ipAliases, setIpAliases] = useState([]);

  async function fetchUsers() {
    setLoading(true);
    const result = await apiClient.get(`${apiBase}?include_resigned=${includeResigned}`);
    if (result.ok) {
      setList(
        (result.data.list || []).map((row) => ({
          ...row,
          department: normalizeDepartmentValue(row.department),
          attendance_time_type: normalizeAttendanceTimeType(row.attendance_time_type, attendanceTypeOptions),
        })),
      );
    } else {
      showToast(result.data?.message || `${entityLabel} 목록 조회에 실패했습니다.`, 'error');
    }
    setLoading(false);
  }

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    apiClient.get('/api/admin/attendance-calendar/ip-aliases')
      .then((result) => {
        if (result.ok && result.data?.success) {
          setIpAliases(normalizeIpAliasOptions(result.data.aliases));
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [includeResigned, attendanceTypeOptions]);

  return { isMobile, includeResigned, setIncludeResigned, list, loading, ipAliases, fetchUsers };
}
